import userManager from './userManager';

const {
   REACT_APP_OAUTH_COGNITO_LOGOUT,
   REACT_APP_AUTHDEPOT_LOGOUT,
   REACT_APP_LOGOUT_URL,
   REACT_APP_OAUTH_CLIENT_ID,
} = process.env;

export const logout = () => {
   // First remove the user from OIDC storage
   userManager.removeUser();

   // Then revoke the token
   userManager.revokeAccessToken()
   .then(() => {
      // Finally redirect to login page
      console.log('Access token revoked successfully');
      window.location.replace(`${REACT_APP_OAUTH_COGNITO_LOGOUT}?client_id=${REACT_APP_OAUTH_CLIENT_ID}&logout_uri=${REACT_APP_AUTHDEPOT_LOGOUT}?callback=${REACT_APP_LOGOUT_URL}`);
   })
   .catch(error => {
      // Even if token revocation fails, still redirect
      console.error('Error revoking access token:', error);
      window.location.replace(`${REACT_APP_OAUTH_COGNITO_LOGOUT}?client_id=${REACT_APP_OAUTH_CLIENT_ID}&logout_uri=${REACT_APP_AUTHDEPOT_LOGOUT}?callback=${REACT_APP_LOGOUT_URL}`);
   })
};